var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1729_11959)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86584,
    y: 4.87402,
    width: 17.0272,
    height: 17.0272,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.04463 0 0 6.04463 0 13.5C0 20.9554 6.04463 27 13.5 27C20.9554 27 27 20.9554 27 13.5C27 6.04463 20.9554 0 13.5 0ZM8.88975 7.53412H18.1102C19.8034 7.53412 20.88 9.36563 20.0284 10.8416L14.337 20.7023C14.252 20.8489 14.1299 20.9707 13.983 21.0553C13.8361 21.1399 13.6695 21.1845 13.5 21.1845C13.3305 21.1845 13.1639 21.1399 13.017 21.0553C12.8701 20.9707 12.748 20.8489 12.663 20.7023L6.97388 10.8416C6.12112 9.36337 7.1955 7.53412 8.88975 7.53412ZM14.3393 9.21712V17.7446L15.579 15.3506L18.567 10.0001C18.6128 9.92021 18.6366 9.82962 18.6361 9.73754C18.6356 9.64545 18.6109 9.55512 18.5643 9.47567C18.5177 9.39623 18.451 9.33048 18.3709 9.28508C18.2908 9.23969 18.2001 9.21624 18.108 9.21712H14.3393ZM8.8875 9.21937C8.79561 9.21838 8.70509 9.24166 8.62508 9.28686C8.54507 9.33206 8.47841 9.39758 8.43184 9.47679C8.38527 9.55601 8.36044 9.64612 8.35985 9.73801C8.35926 9.8299 8.38294 9.92032 8.4285 10.0001L11.4187 15.3484L12.6585 17.7446V9.21937H8.8875Z",
    fill: "#0088CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1729_11959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.482616416b892322c5ec3b6b42617c27.svg";
export { ForwardRef as ReactComponent };